import type { ApiQuery } from '../../../shared/api/contracts'
import type { CategoryReviewItem, CategoryReviewUpdate } from '../../../shared/api/models'
import { apiRequest } from './transport'

export async function fetchCategoryReviewItems(params?: ApiQuery<'GET /admin/expenses/category-review'>, signal?: AbortSignal) {
  const u = new URLSearchParams()
  if (params?.limit != null) u.set('limit', String(params.limit))
  if (params?.from) u.set('from', params.from)
  if (params?.to) u.set('to', params.to)
  if (params?.cursor) u.set('cursor', params.cursor)
  const qs = u.toString()
  return apiRequest<'GET /admin/expenses/category-review'>(`/admin/expenses/category-review${qs ? `?${qs}` as const : ''}`, { signal })
}

export async function suggestCategoryReview(items: CategoryReviewItem[], signal?: AbortSignal) {
  return apiRequest<'POST /admin/expenses/category-review/suggest'>(
    '/admin/expenses/category-review/suggest',
    { method: 'POST', signal, body: {
      items: items.map((item) => ({
        expenseId: item.expenseId,
        itemId: item.itemId ?? null,
        idx: item.idx,
        amount: item.amount,
        currency: item.currency,
        currentCategory: item.category ?? null,
        currentSubcategory: item.subcategory ?? null,
        comment: item.comment ?? null,
        sourceText: item.sourceText ?? null,
        spentAt: item.spentAt ?? null,
        confidence: item.confidence ?? null,
        question: item.question ?? null,
      })),
    } },
  )
}

export async function applyCategoryReviewSuggestions(updates: CategoryReviewUpdate[], signal?: AbortSignal) {
  return apiRequest<'POST /admin/expenses/category-review/apply'>(
    '/admin/expenses/category-review/apply',
    { method: 'POST', signal, body: { updates } },
  )
}
